var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function cloneNode(node, deep) {
        if (deep === void 0) { deep = false; }
        return node.cloneNode(deep);
    }
    function loopHtmlCollection(collection) {
        return [].slice.call(collection);
    }
    var NavLevel = /** @class */ (function () {
        function NavLevel(headerElement) {
            this.children = [];
            this.headerElement = headerElement;
        }
        NavLevel.prototype.addChild = function (child) {
            this.children.push(child);
        };
        NavLevel.prototype.getChildren = function () {
            return this.children;
        };
        NavLevel.prototype.getHeaderElement = function () {
            return this.headerElement;
        };
        NavLevel.prototype.hasChildren = function () {
            return this.children.length > 0;
        };
        NavLevel.prototype.isActive = function () {
            return this.headerElement.classList.contains('active');
        };
        return NavLevel;
    }());
    var BreadcrumbNavCollector = /** @class */ (function () {
        function BreadcrumbNavCollector() {
            this.initialized = false;
            this.breadcrumbItems = document.querySelectorAll('.breadcrumb .breadcrumb-item');
        }
        BreadcrumbNavCollector.prototype.getRootNavLevel = function () {
            this.collectNavLevels();
            return this.rootNavLevel;
        };
        BreadcrumbNavCollector.prototype.collectHoverLinks = function (breadcrumbItem) {
            var e_1, _a;
            var childLinks = this.getBreadcrumbChildLinks(breadcrumbItem);
            try {
                for (var _b = __values(loopHtmlCollection(childLinks)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var childLink = _c.value;
                    var hoverLinkClone = cloneNode(childLink, true);
                    hoverLinkClone.classList.remove('subnav-item');
                    var childNavLevel = new NavLevel(hoverLinkClone);
                    this.currentNavLevel.addChild(childNavLevel);
                    if (childLink.classList.contains('active')) {
                        this.nextNavLevel = childNavLevel;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
        };
        BreadcrumbNavCollector.prototype.collectNavLevels = function () {
            var e_2, _a;
            if (this.initialized) {
                return;
            }
            this.initialized = true;
            if (!this.breadcrumbItems.length) {
                return;
            }
            try {
                for (var _b = __values(loopHtmlCollection(this.breadcrumbItems)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var breadcrumbItem = _c.value;
                    // Failsafe if for some reason the next lavel could not be detected!
                    if (this.rootNavLevel && !this.currentNavLevel) {
                        break;
                    }
                    // Exclude root link and clipped nav.
                    if (breadcrumbItem.classList.contains('root') || breadcrumbItem.classList.contains('clipped')) {
                        continue;
                    }
                    if (!this.rootNavLevel) {
                        this.initRootElement(breadcrumbItem);
                        if (!this.rootNavLevel) {
                            return;
                        }
                    }
                    this.nextNavLevel = null;
                    this.collectHoverLinks(breadcrumbItem);
                    this.currentNavLevel = this.nextNavLevel;
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_2) throw e_2.error; }
            }
        };
        BreadcrumbNavCollector.prototype.getBreadcrumbChildLinks = function (breadcrumbItem) {
            if (breadcrumbItem.classList.contains('active')) {
                return document.querySelectorAll('.navbar-breadcrumb-sub a.subnav-item');
            }
            return breadcrumbItem.querySelectorAll('.subnav-item-wrapper a.subnav-item');
        };
        BreadcrumbNavCollector.prototype.getPlainDropdownToggleLink = function (el) {
            var link = el.querySelector('.dropdown-toggle');
            if (!link) {
                return null;
            }
            var clonedLink = cloneNode(link, true);
            clonedLink.removeAttribute('id');
            clonedLink.removeAttribute('class');
            return clonedLink;
        };
        BreadcrumbNavCollector.prototype.initRootElement = function (breadcrumbItem) {
            var rootLink = this.getPlainDropdownToggleLink(breadcrumbItem);
            if (!rootLink) {
                return;
            }
            this.rootNavLevel = new NavLevel(rootLink);
            this.currentNavLevel = this.rootNavLevel;
        };
        return BreadcrumbNavCollector;
    }());
    var MenuBuilder = /** @class */ (function () {
        function MenuBuilder() {
        }
        MenuBuilder.prototype.buildMobileMenu = function () {
            var rootList = document.createElement('ul');
            var breadcrumbNavCollector = new BreadcrumbNavCollector();
            var rootNavLevel = breadcrumbNavCollector.getRootNavLevel();
            if (rootNavLevel) {
                rootList.append(this.createNavbarHTML(rootNavLevel));
                return rootList;
            }
            var homepageNavAvailable = this.appendMenuLinks(rootList, '#navbarMobileMain a');
            if (homepageNavAvailable) {
                return rootList;
            }
            // Fallback to portal nav.
            var portalLinksAvailable = this.appendMenuLinks(rootList, '#navbarMain a');
            if (portalLinksAvailable) {
                return rootList;
            }
            // Fallback to homepage link as last resort.
            rootNavLevel = new NavLevel(this.createHomepageLink());
            rootList.append(this.createNavbarHTML(rootNavLevel));
            return rootList;
        };
        MenuBuilder.prototype.createHomepageLinkWrapper = function () {
            var homepageLinkWrapper = document.createElement('div');
            homepageLinkWrapper.append(this.createHomepageLink());
            return homepageLinkWrapper;
        };
        MenuBuilder.prototype.appendMenuLinks = function (rootList, selector) {
            var e_3, _a;
            var portalLinks = document.querySelectorAll(selector);
            if (portalLinks.length === 0) {
                return false;
            }
            try {
                for (var _b = __values(loopHtmlCollection(portalLinks)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var portalLink = _c.value;
                    var portalLinkClone = cloneNode(portalLink, true);
                    portalLinkClone.classList.remove('nav-link');
                    var portalLinkListItem = document.createElement('li');
                    portalLinkListItem.append(portalLinkClone);
                    rootList.append(portalLinkListItem);
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_3) throw e_3.error; }
            }
            return true;
        };
        MenuBuilder.prototype.createHomepageLink = function () {
            var homepageLink = document.querySelector('a.navbar-brand');
            var homepageLinkClone = cloneNode(homepageLink);
            homepageLinkClone.classList.remove('navbar-brand');
            homepageLinkClone.textContent = homepageLinkClone.getAttribute('data-mobile-nav-label');
            return homepageLinkClone;
        };
        MenuBuilder.prototype.createNavbarHTML = function (navLevel) {
            var e_4, _a;
            var listItem = document.createElement('li');
            if (!navLevel.hasChildren()) {
                if (navLevel.isActive()) {
                    listItem.setAttribute('class', 'active');
                }
                listItem.append(navLevel.getHeaderElement());
                return listItem;
            }
            listItem.setAttribute('class', 'active');
            listItem.append(navLevel.getHeaderElement());
            var subList = document.createElement('ul');
            listItem.append(subList);
            try {
                for (var _b = __values(navLevel.getChildren()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var child = _c.value;
                    subList.append(this.createNavbarHTML(child));
                }
            }
            catch (e_4_1) { e_4 = { error: e_4_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_4) throw e_4.error; }
            }
            return listItem;
        };
        return MenuBuilder;
    }());
    exports.default = MenuBuilder;
});
